import { useMemo } from "react"

export const useGetMonths = () => {
    return useMemo(() => [
        { id: 1, label: "January", value: 1 },
        { id: 2, label: "February", value: 2 },
        { id: 3, label: "March", value: 3 },
        { id: 4, label: "April", value: 4 },
        { id: 5,label: "May", value: 5 },
        { id: 6, label: "June", value: 6 },
        { id: 7, label: "July", value: 7 },
        { id: 8, label: "August", value: 8 },
        { id: 9, label: "September", value: 9 },
        { id: 10, label: "October", value: 10 },
        { id: 11, label: "November", value: 11 },
        { id: 12, label: "December", value: 12 },
    ], [])
}